import { Injectable } from "@angular/core";
import { PaginationService } from "../../shared/services/pagination.service";
import { AssetScroll } from "@models/asset_scroll";
import { CryptocoinService } from "@main-services/currency";
import { Cryptocoin } from "@models";
import { PaginatedEvent } from "@models/pagination_event";
import { ApicallService } from "@core-services/apicall.service";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { CoreStoreFacade } from "@modules/+new/core/core-store/domain/+state/core-store.facade";

@Injectable()
export class AssetsContactsScrollService extends PaginationService<BpSelectOption> {
	private selectedCoinIds: string[] = []; // List of all currently selected coins in contact fields
	private filteredOutIds: string[] = []; // List of all coins that were filtered out for this specific dropdown

	public constructor(
		public apiCallService: ApicallService,
		private coinService: CryptocoinService,
		protected readonly coreStoreFacade: CoreStoreFacade
	) {
		super(coreStoreFacade, apiCallService, "assets", "v3", Cryptocoin);
	}

	public convertPaginationList(list: AssetScroll[]): BpSelectOption[] {
		if (!list) {
			return [];
		}

		const coinList: Cryptocoin[] = list
			.map((a: AssetScroll) => this.coinService.list.find((t) => t.getId() === a.getId()))
			.filter((c) => !!c && !c.isIndexOnly())
			.filter((coin) => this.filterBySelected(coin.getId()));
		return coinList.map((c: Cryptocoin) => this.parseCoinToOption(c));
	}

	public getNewEvent(): PaginatedEvent {
		const event: PaginatedEvent = new PaginatedEvent();
		event.setType(["cryptocoin"]);
		return event;
	}

	private filterBySelected(coinId: string): boolean {
		if (!this.selectedCoinIds.includes(coinId)) {
			return true;
		}
		if (!this.filteredOutIds.includes(coinId)) {
			this.filteredOutIds.push(coinId);
		}
		return false;
	}

	// Re-Filters the list when a different dropdown-selection is changed without needing to re-fetch API all the time
	public reFilterList(coinId: string): void {
		let filteredOptions: BpSelectOption[] = [...this.list.getValue()];
		if (this.filteredOutIds.includes(coinId)) {
			const coin: Cryptocoin = this.coinService.getItemById(coinId);
			const option: BpSelectOption = this.parseCoinToOption(coin);
			filteredOptions.unshift(option);
			this.filteredOutIds = this.filteredOutIds.filter((id) => id !== coinId);
		}
		filteredOptions = filteredOptions.filter((option) => {
			const coin: Cryptocoin = this.coinService.findByName(option.name);
			return this.filterBySelected(coin.getId());
		});
		this.list.next(filteredOptions);
	}

	public parseCoinToOption(coin: Cryptocoin): BpSelectOption {
		return {
			name: coin.getName(),
			iconUrl: coin.getLogo(),
			value: coin.getSymbol(true) + "_address"
		} as BpSelectOption;
	}

	// ---------------------- BELOW: necessary for tracking the current dropdown selection

	public updateSelectedIds(ids: string[]): void {
		this.selectedCoinIds = ids;
	}
}
